module.exports = __webpack_public_path__ + "static/img/no_detail.b159fb1e.png";